// extracted by mini-css-extract-plugin
export var header = "_ul-1";
export var maskBottom = "_ul-6";
export var maskMiddle = "_ul-7";
export var maskTop = "_ul-5";
export var root = "_ul-0";
export var scrollDownButton = "_ul-3";
export var scrollDownButtonHidden = "_ul-4";
export var viewport = "_ul-2";